import { z } from 'zod';

export enum TaskCardType {
  STANDARD = 'Standard',
  ALERT = 'Alert',
  DATA_ONBOARDING_INCIDENT = 'DataOnboardingIncident',
}

export const taskCardTypeSchema = z.nativeEnum(TaskCardType);
